import React, {useEffect, useRef} from 'react';

const PREVIEW_ID = 'admin-photo-hover-preview';
const PREVIEW_IMG_ID = 'admin-photo-hover-preview-img';

function ensurePreviewNode() {
    let container = document.getElementById(PREVIEW_ID);
    let image = document.getElementById(PREVIEW_IMG_ID);

    if (!container) {
        container = document.createElement('div');
        container.id = PREVIEW_ID;
        container.style.position = 'fixed';
        container.style.left = '-9999px';
        container.style.top = '-9999px';
        container.style.zIndex = '99999';
        container.style.pointerEvents = 'none';
        container.style.display = 'none';
        document.body.appendChild(container);
    }

    if (!image) {
        image = document.createElement('img');
        image.id = PREVIEW_IMG_ID;
        image.style.maxWidth = '420px';
        image.style.maxHeight = '320px';
        image.style.borderRadius = '10px';
        image.style.border = '1px solid #e5e7eb';
        image.style.boxShadow = '0 20px 35px rgba(0,0,0,.2)';
        image.style.background = '#fff';
        image.style.objectFit = 'contain';
        container.appendChild(image);
    }

    return {container, image};
}

const PhotoThumbWithHover = ({
    src,
    alt = 'Fotografie',
    className = 'w-14 h-14 rounded object-cover border border-gray-200'
}) => {
    const rafRef = useRef(null);
    const mountedRef = useRef(false);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
                rafRef.current = null;
            }
        };
    }, []);

    if (!src) {
        return <span className="text-xs opacity-60">Bez fotografie</span>;
    }

    const onMouseEnter = (event) => {
        const {container, image} = ensurePreviewNode();
        image.src = src;
        image.alt = alt;
        container.style.display = 'block';
        container.style.left = `${event.clientX + 16}px`;
        container.style.top = `${event.clientY + 16}px`;
    };

    const onMouseMove = (event) => {
        if (!mountedRef.current) return;
        if (rafRef.current) cancelAnimationFrame(rafRef.current);
        const x = event.clientX;
        const y = event.clientY;
        rafRef.current = requestAnimationFrame(() => {
            const container = document.getElementById(PREVIEW_ID);
            if (!container) return;
            container.style.left = `${x + 16}px`;
            container.style.top = `${y + 16}px`;
            rafRef.current = null;
        });
    };

    const onMouseLeave = () => {
        if (rafRef.current) {
            cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        }
        const container = document.getElementById(PREVIEW_ID);
        if (!container) return;
        container.style.display = 'none';
        container.style.left = '-9999px';
        container.style.top = '-9999px';
    };

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onMouseEnter={onMouseEnter}
            onMouseMove={onMouseMove}
            onMouseLeave={onMouseLeave}
        />
    );
};

export default PhotoThumbWithHover;
